import { writable } from 'svelte/store';
import ComponentHome from '../pages/Home.svelte';
import ComponentLogin from '../pages/Login.svelte';
import ComponentPageNosEntreprises from '../pages/NosEntreprises.svelte';
import ComponentPageEntreprise from '../pages/Entreprise.svelte';
import ComponentPageNosMembres from '../pages/NosMembres.svelte';
import ComponentPageRegistration from '../pages/Registration.svelte';
import ComponentPageResetPassword from '../pages/ResetPassword.svelte';
import ComponentPageModifPassword from '../pages/ModifPassword.svelte';
import ComponentPageUserAccount from '../pages/UserAccount.svelte';
import ComponentPageNosEvenements from '../pages/NosEvenements.svelte';
import ComponentPageNosVideos from '../pages/NosVideos.svelte';
import ComponentPageNosChantiers from '../pages/NosChantiers.svelte';
import ComponentPageChantier from '../pages/Chantier.svelte';
import ComponentPageNosLivrables from '../pages/NosLivrables.svelte';
import ComponentPageRealisations from '../pages/Realisations.svelte';
import ComponentPagePressRevue from '../pages/PressRevue.svelte';
import ComponentPagePlenaries from '../pages/Plenaries.svelte';
import ComponentPageEcosystem from '../pages/Ecosystem.svelte';
import ComponentPageDevenirPartenaire from '../pages/DevenirPartenaire.svelte';
import ComponentPageDevenirMembre from '../pages/DevenirMembre.svelte';
import ComponentPagePartenaire from '../pages/Partenaire.svelte';
import ComponentPageBlog from '../pages/Blog.svelte';
import ComponentPageArticle from '../pages/Article.svelte';
import ComponentPageMyArticles from '../pages/MyArticles.svelte';
import ComponentPageArticleEdition from '../pages/ArticleEdition.svelte';
import ComponentPagePress from '../pages/Press.svelte';
import ComponentPageNosPartenaires from '../pages/NosPartenaires.svelte';
import ComponentPageNosPartenairesFormations from '../pages/NosPartenairesFormations.svelte';
import { idPageHome, idPageLogin, idPageEntreprises, idPageEntreprise, idPageMembres, idPageRegistration, idPageResetPassword, idPageModifPassword, idPageUserAccount, idPageNosEvenements, idPageNosVideos, idPageNosChantiers, idPageChantier, idPageNosLivrables, idPagePlenaries, idPagePressRevue, idPageRealisations, idPageEcosystem, idPageDevenirMembre, idPageDevenirPartenaire, idPagePartenaire, idPageBlog, idPageArticle, idPageMyArticles, idPageArticleEdition, idPagePress, idPageNosPartenaires, idPageNosPartenairesFormations, namePageHome, namePageLogin, namePageEntreprises, namePageEntreprise, namePageMembres, namePageRegistration, namePageResetPassword, namePageModifPassword, namePageUserAccount, namePageNosEvenements, namePageNosVideos, namePageNosChantiers, namePageChantier, namePageNosLivrables, namePagePlenaries, namePagePressRevue, namePageRealisations, namePageEcosystem, namePageDevenirMembre, namePageDevenirPartenaire, namePagePartenaire, namePageBlog, namePageArticle, namePageMyArticles, namePageArticleEdition, namePagePress, namePageNosPartenaires, namePageNosPartenairesFormations, } from "./router2";
export const storeCurRoute = writable(idPageHome);
export const routes = [];
export const pageHome = { id: idPageHome, name: namePageHome, anchor: '', component: ComponentHome };
routes.push(pageHome);
export const login = { id: idPageLogin, name: namePageLogin, anchor: '', component: ComponentLogin };
routes.push(login);
export const nosentreprises = { id: idPageEntreprises, name: namePageEntreprises, anchor: '', component: ComponentPageNosEntreprises };
routes.push(nosentreprises);
export const entreprise = { id: idPageEntreprise, name: namePageEntreprise, anchor: '', component: ComponentPageEntreprise };
routes.push(entreprise);
export const membres = { id: idPageMembres, name: namePageMembres, anchor: '', component: ComponentPageNosMembres };
routes.push(membres);
export const registration = { id: idPageRegistration, name: namePageRegistration, anchor: '', component: ComponentPageRegistration };
routes.push(registration);
export const resetpassword = { id: idPageResetPassword, name: namePageResetPassword, anchor: '', component: ComponentPageResetPassword };
routes.push(resetpassword);
export const modifpassword = { id: idPageModifPassword, name: namePageModifPassword, anchor: '', component: ComponentPageModifPassword };
routes.push(modifpassword);
export const useraccount = { id: idPageUserAccount, name: namePageUserAccount, anchor: '', component: ComponentPageUserAccount };
routes.push(useraccount);
export const nosevenements = { id: idPageNosEvenements, name: namePageNosEvenements, anchor: '', component: ComponentPageNosEvenements };
routes.push(nosevenements);
export const nosvideos = { id: idPageNosVideos, name: namePageNosVideos, anchor: '', component: ComponentPageNosVideos };
routes.push(nosvideos);
export const noschantiers = { id: idPageNosChantiers, name: namePageNosChantiers, anchor: '', component: ComponentPageNosChantiers };
routes.push(noschantiers);
export const chantier = { id: idPageChantier, name: namePageChantier, anchor: '', component: ComponentPageChantier };
routes.push(chantier);
export const noslivrables = { id: idPageNosLivrables, name: namePageNosLivrables, anchor: '', component: ComponentPageNosLivrables };
routes.push(noslivrables);
export const realisations = { id: idPageRealisations, name: namePageRealisations, anchor: '', component: ComponentPageRealisations };
routes.push(realisations);
export const pressrevue = { id: idPagePressRevue, name: namePagePressRevue, anchor: '', component: ComponentPagePressRevue };
routes.push(pressrevue);
export const plenaries = { id: idPagePlenaries, name: namePagePlenaries, anchor: '', component: ComponentPagePlenaries };
routes.push(plenaries);
export const ecosystem = { id: idPageEcosystem, name: namePageEcosystem, anchor: '', component: ComponentPageEcosystem };
routes.push(ecosystem);
export const devenirpartenaire = { id: idPageDevenirPartenaire, name: namePageDevenirPartenaire, anchor: '', component: ComponentPageDevenirPartenaire };
routes.push(devenirpartenaire);
export const devenirmembre = { id: idPageDevenirMembre, name: namePageDevenirMembre, anchor: '', component: ComponentPageDevenirMembre };
routes.push(devenirmembre);
export const partenaire = { id: idPagePartenaire, name: namePagePartenaire, anchor: '', component: ComponentPagePartenaire };
routes.push(partenaire);
export const blog = { id: idPageBlog, name: namePageBlog, anchor: '', component: ComponentPageBlog };
routes.push(blog);
export const article = { id: idPageArticle, name: namePageArticle, anchor: '', component: ComponentPageArticle };
routes.push(article);
export const myarticles = { id: idPageMyArticles, name: namePageMyArticles, anchor: '', component: ComponentPageMyArticles };
routes.push(myarticles);
export const articleedition = { id: idPageArticleEdition, name: namePageArticleEdition, anchor: '', component: ComponentPageArticleEdition };
routes.push(articleedition);
export const press = { id: idPagePress, name: namePagePress, anchor: '', component: ComponentPagePress };
routes.push(press);
export const nospartenaires = { id: idPageNosPartenaires, name: namePageNosPartenaires, anchor: '', component: ComponentPageNosPartenaires };
routes.push(nospartenaires);
export const nospartenairesformations = { id: idPageNosPartenairesFormations, name: namePageNosPartenairesFormations, anchor: '', component: ComponentPageNosPartenairesFormations };
routes.push(nospartenairesformations);
/**
 * redirectTo
 *
 * @param path
 */
export function redirectTo(idPage, params = "") {
    storeCurRoute.set(idPage);
    window.history.pushState({ path: "#" + idPage }, '', window.location.origin + "/" + idPage + params);
}
/**
 * historyNavigation
 * Écoute de l’événement popstate qui est lancé lorsque l’historique change.
 * Le clic sur le back du navigateur est écouté et la route courante actualisée
 *
 * @param event
 */
export function historyNavigation(event) {
    // change current router path
    if (event.state.path.indexOf("#") >= 0 && storeCurRoute != undefined) {
        storeCurRoute.set(event.state.path.replace('#', ''));
    }
}
